/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkDateUnitEnum } from './workDateUnitEnum';


/**
 * Factor resource assignment work units (new)
 */
import { ValidateUtils } from 'app/shared/utils';

export class FactorWorkUnitsNew { 
    workUnitsDateUnitType?: WorkDateUnitEnum;
    /**
     * Work units date
     */
    workUnitsDate?: string;
    /**
     * Work units
     */
    workUnits?: number;

    constructor(item?: Partial<FactorWorkUnitsNew>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            workUnitsDateUnitType: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.workUnitsDateUnitType : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            workUnitsDate: {
                type: 'date',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.workUnitsDate : itemOrValue;

                    if (itemOrValue?.workUnitsDate != null) {
                        if (itemOrValue.workUnitsDate === '') {
                            itemOrValue.workUnitsDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date') >= 0) {
                            itemOrValue.workUnitsDate = parseInt(itemOrValue.workUnitsDate.toString(), 10);
                        } else if (['float'].indexOf('date') >= 0) {
                            itemOrValue.workUnitsDate = parseFloat(itemOrValue.workUnitsDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date');
                    if (['uuid'].indexOf('date') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            workUnits: {
                type: 'float',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.workUnits : itemOrValue;

                    if (itemOrValue?.workUnits != null) {
                        if (itemOrValue.workUnits === '') {
                            itemOrValue.workUnits = undefined;
                        } else if (['int32', 'int64'].indexOf('float') >= 0) {
                            itemOrValue.workUnits = parseInt(itemOrValue.workUnits.toString(), 10);
                        } else if (['float'].indexOf('float') >= 0) {
                            itemOrValue.workUnits = parseFloat(itemOrValue.workUnits.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'float');
                    if (['uuid'].indexOf('float') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: FactorWorkUnitsNew.isValid,
        };
    }

    static isValid(obj: FactorWorkUnitsNew): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = FactorWorkUnitsNew.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.workUnitsDateUnitType.isValid(item);
            result = result && validationObject.workUnitsDate.isValid(item);
            result = result && validationObject.workUnits.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

